import React from 'react'

interface SwitcherOption {
  value: string | boolean
  label: string
}

interface SwitcherProps {
  options: SwitcherOption[]
  value: string
  onSwitch: (value: string | boolean) => void
}

const Switcher = ({ options, value, onSwitch }: SwitcherProps): JSX.Element => {
  const [firstOption, secondOption, thirdOption] = options

  if (options.length < 2 || options.length > 3) {
    return <></>
  }

  if (options.length === 2) {
    return (
      <div className="flex bg-lightGrey rounded-4 border-2 border-successGreen">
        <button
          type="button"
          onClick={() => {
            onSwitch(firstOption.value)
          }}
          className={`px-4 py-2 rounded-l-3 transition-all flex-1 font-medium min-w-[100px] ${
            value === firstOption.value
              ? 'bg-successGreen text-white shadow-sm'
              : 'bg-transparent text-black hover:text-groupBlue'
          }`}>
          {firstOption.label}
        </button>
        <button
          type="button"
          onClick={() => {
            onSwitch(secondOption.value)
          }}
          className={`px-4 py-2 rounded-r-3 transition-all flex-1 font-medium min-w-[100px] ${
            value === secondOption.value
              ? 'bg-successGreen text-white shadow-sm'
              : 'bg-transparent text-black hover:text-groupBlue'
          }`}>
          {secondOption.label}
        </button>
      </div>
    )
  }

  return (
    <div className="flex bg-lightGrey rounded-4 border-2 border-successGreen">
      <button
        type="button"
        onClick={() => {
          onSwitch(firstOption.value)
        }}
        className={`px-4 py-2 rounded-l-3 transition-all flex-1 font-medium min-w-[100px] ${
          value === firstOption.value
            ? 'bg-successGreen text-white shadow-sm'
            : 'bg-transparent text-black hover:text-groupBlue'
        }`}>
        {firstOption.label}
      </button>
      <button
        type="button"
        onClick={() => {
          onSwitch(secondOption.value)
        }}
        className={`px-4 py-2 transition-all flex-1 border-r-2 border-l-2 border-successGreen font-medium min-w-[100px] ${
          value === secondOption.value
            ? 'bg-successGreen text-white shadow-sm'
            : 'bg-transparent text-black hover:text-groupBlue'
        }`}>
        {secondOption.label}
      </button>
      <button
        type="button"
        onClick={() => {
          onSwitch(thirdOption.value)
        }}
        className={`px-4 py-2 rounded-r-3 transition-all flex-1 font-medium min-w-[100px] ${
          value === thirdOption.value
            ? 'bg-successGreen text-white shadow-sm'
            : 'bg-transparent text-black hover:text-groupBlue'
        }`}>
        {thirdOption.label}
      </button>
    </div>
  )
}

export default Switcher
